import { sleep } from "@lib/functions"
import clsx from "clsx"
import React from "react"

interface VideoThumbnailProps {
  url: string
  videoRef: React.RefObject<HTMLVideoElement>
}

export const VideoThumbnail = ({ videoRef, url }: VideoThumbnailProps) => {
  return (
    <video
      muted
      className={clsx("w-full h-full absolute top-0 left-0 z-[1] rounded-10 object-cover")}
      ref={videoRef}
      src={url}
    />
  )
}
